import { render, staticRenderFns } from "./localizadores.vue?vue&type=template&id=37a04c10"
import script from "./localizadores.vue?vue&type=script&lang=js"
export * from "./localizadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports